/* eslint-disable promise/avoid-new */
class CitationCoordinatesQueue {
  constructor(concurrency = 1) {
    this.queue = [];
    this.running = 0;
    this.concurrency = concurrency;
    this.worker = null;
  }

  initWorker() {
    if (!this.worker) {
      this.worker = new Worker(new URL('../workers/get-citation-coordinates-worker.js', import.meta.url));
    }
    return this.worker;
  }

  terminate() {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null;
    }
  }

  async processNext() {
    if (this.running >= this.concurrency || this.queue.length === 0) {
      return;
    }

    const { task, resolve, reject } = this.queue.shift();
    this.running++;

    try {
      const worker = this.initWorker();
      
      const result = await new Promise((resolve, reject) => {
        const messageHandler = (e) => {
          worker.removeEventListener('message', messageHandler);
          // eslint-disable-next-line no-use-before-define
          worker.removeEventListener('error', errorHandler);
          resolve(e.data);
        };

        const errorHandler = (error) => {
          worker.removeEventListener('message', messageHandler);
          worker.removeEventListener('error', errorHandler);
          reject(error);
        };

        worker.addEventListener('message', messageHandler);
        worker.addEventListener('error', errorHandler);
        
        worker.postMessage(task);
      });

      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      this.running--;
      this.processNext();
    }
  }

  enqueue(modelOutput, abstract, sentence, isModelFinished) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        task: { modelOutput, abstract, sentence, isModelFinished },
        resolve,
        reject
      });

      this.processNext();
    });
  }

  clear() {
    this.queue = [];
  }
}

// Create a singleton instance
const citationQueue = new CitationCoordinatesQueue(1);

export const getCitationCoordinates = (modelOutput, abstract, sentence, isModelFinished) => {
  return citationQueue.enqueue(modelOutput, abstract, sentence, isModelFinished);
};

export const getCitationQueueStatus = () => citationQueue.getStatus();
export const clearCitationQueue = () => citationQueue.clear();
export const terminateCitationQueue = () => citationQueue.terminate();

/* eslint-enable promise/avoid-new */